import reactNativeComms from '../../reactNativeComms'
import type { AnalyticsProvider } from './AnalyticsManager.types'
import { sendRequest, isMobileApp } from 'utils/utils'

const dependencies = {
	sendRequest,
	isMobileApp,
	async sendEvent(analyticsProvider: AnalyticsProvider, data: object) {
		reactNativeComms.sendMessage.sendAnalyticsEventV2(analyticsProvider, data)
	},
}

export default dependencies

export type DependencyType = typeof dependencies
